import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTenant } from '../contexts/TenantContext';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from './Logo';

/**
 * PortalGuard: Route guard that checks if user has access to a specific portal.
 * Uses the portals list (which portals the user CAN access) rather than 
 * strictly checking active context type, to avoid race conditions during switches.
 */
export default function PortalGuard({ portal, children }) {
  const { user, loading: authLoading } = useAuth();
  const { portals, loading: tenantLoading } = useTenant();

  if (authLoading || tenantLoading) {
    return (
      <div className="min-h-screen bg-[#06060A] flex items-center justify-center" data-testid="cyboard-splash">
        <div className="flex flex-col items-center gap-4 animate-pulse">
          <Logo variant="icon" size="xl" clickable={false} />
          <Logo variant="wordmark" size="md" clickable={false} />
          <p className="text-[#666] text-[11px] tracking-[0.2em] uppercase mt-2">Loading CyBoard…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Check portal access via the portals list
  if (portal && !portals.includes(portal)) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
